import React from "react";
import { connect } from "react-redux";
import "./JobView.scss";

import axios from "axios";

import { useNavigate } from "react-router-dom";

import { useToast, Button } from "@chakra-ui/react";
import { EditIcon, DeleteIcon, ChevronRightIcon } from "@chakra-ui/icons";

import { updateSelectedJob } from "../../../state/action-creators";

import moment from "moment";

const JobView = (props) => {
  const {
    jobDetails,
    fetchAllJobs,
    updateSelectedJob,
    isCrudButtonVisible = false,
  } = props;

  const navigate = useNavigate();
  const toast = useToast();

  const handleEditJobClick = async (e) => {
    e?.stopPropagation();
    await updateSelectedJob(jobDetails);
    navigate(`/careers/${process.env.REACT_APP_CAREER_CRUD_ROUTE}/create-job`);
  };

  const handleDeleteJobClick = async (e) => {
    e?.stopPropagation();
    if (jobDetails?._id) {
      await axios.delete(
        `https://workoza-server-vercel.vercel.app/api/job/${jobDetails?._id}`
      );
      toast({
        title: "Job deleted successfully.",
        status: "success",
        position: "bottom-left",
        duration: 5000,
        isClosable: true,
      });
      fetchAllJobs();
    }
  };

  const handleApplyNowJobClick = (e) => {
    e?.stopPropagation();
    if (jobDetails?._id) {
      navigate(`/careers/apply-now/${jobDetails?._id}`);
    }
  };

  const handleJobClick = (e) => {
    e?.preventDefault();
    if (jobDetails?._id) {
      if (isCrudButtonVisible) {
        navigate(
          `/careers/${process.env.REACT_APP_CAREER_CRUD_ROUTE}/view-job/${jobDetails?._id}`
        );
      } else {
        navigate(`/careers/view-job/${jobDetails?._id}`);
      }
    }
  };

  return (
    <div className="jobViewContainer" onClick={handleJobClick}>
      <div className="jobViewWrapper">
        <div className="jobViewFeedContainer">
          <div className="jobViewTopContainer">
            <div className="jobViewDescriptionText">{jobDetails?.title}</div>
            <div className="jobViewTypeContainer">
              <div className="jobViewTypeText">
                Job ID:
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="jobViewBoldText">{jobDetails?.jobId}</span>
              </div>
              <div className="jobViewTypeText">
                Job type: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="jobViewBoldText">{jobDetails?.jobType}</span>
              </div>
              <div className="jobViewTypeText">
                Location: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="jobViewBoldText">{jobDetails?.location}</span>
              </div>
              <div className="jobViewTypeText">
                Posted on: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="jobViewBoldText">
                  {moment(jobDetails?.createdAt).format("DD MMM, YYYY")}
                </span>
              </div>
            </div>
          </div>
          {isCrudButtonVisible ? (
            <div className="jobViewBottomContainer">
              <Button
                rightIcon={<EditIcon />}
                size="md"
                variant="solid"
                color="#ffffff"
                background="#b0b0b0"
                _hover={{ background: "#717171", color: "#f9f9f9" }}
                onClick={handleEditJobClick}
              >
                Edit
              </Button>
              <Button
                rightIcon={<DeleteIcon />}
                size="md"
                variant="solid"
                color="#ffffff"
                background="#d33853"
                _hover={{ background: "#af273e", color: "#f9f9f9" }}
                onClick={handleDeleteJobClick}
              >
                Delete
              </Button>
            </div>
          ) : (
            <div className="jobViewApplyBottomContainer">
              <Button
                rightIcon={<ChevronRightIcon />}
                size="md"
                variant="solid"
                color="#ffffff"
                background="#d33853"
                _hover={{ background: "#af273e", color: "#f9f9f9" }}
                onClick={handleApplyNowJobClick}
              >
                Apply Now
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapActionCreators = {
  updateSelectedJob,
};

export default connect(null, mapActionCreators)(JobView);
